module.exports = __webpack_public_path__ + "static/media/home-internet.9a82de57.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/home-internet.svg
// module id = 3838
// module chunks = 0